import { notification } from 'antd';

notification.config({
  placement: 'top',
  duration: 0,
  maxCount: 1,
});

const defaultNotification = {
  showSuccess: (message, duration) => notification.success({
    message,
    duration,
    style: { width: '100%', backgroundColor: '#fff2f0', border: '1px solid #f6ffed' },
  }),
  showError: (message, duration) => notification.error({
    message,
    duration,
    style: { width: '100%', backgroundColor: '#fff2f0', border: '1px solid #ffccc7' },
  }),
  close: () => notification.destroy()
};

export default defaultNotification;